import { formatCompact } from '@betty/toolkit/utils';
import {
  DepositPromo,
  DepositPromoRewardTarget,
} from '../../../../state/deposit/deposit.types';

export const aggregateRewards = (rewards: DepositPromo['rewards']) =>
  Object.values(
    rewards.reduce<
      Partial<
        Record<
          DepositPromoRewardTarget,
          {
            type: `${DepositPromoRewardTarget}`;
            amount: number;
          }
        >
      >
    >((accumulator, { rewardTarget, rewardAmount }) => {
      if (
        rewardTarget === 'Bonus' ||
        rewardTarget === 'BettyPoints' ||
        !rewardAmount
      ) {
        return accumulator;
      }

      if (accumulator[rewardTarget] === undefined) {
        accumulator[rewardTarget] = {
          type: rewardTarget,
          amount: 0,
        };
      }

      accumulator[rewardTarget].amount += rewardAmount;

      return accumulator;
    }, {}),
  ).map(({ type, amount }) => ({
    type,
    amount: formatCompact(amount),
  }));
